/**
 * @author: xzl_2021
 * @date: 2025/03/12
 * @desc: inputNumber数字输入框输入限制
 */
export const inputNumberDigitalDetection = {
  mounted(el) {
    const input = el.querySelector('input');
    if (!input) return;

    let lastValidValue = input.value || '1';

    input.addEventListener('compositionstart', () => {
      input.setAttribute('compositing', 'true');
      lastValidValue = input.value || '1';
    });

    input.addEventListener('compositionend', (e) => {
      input.removeAttribute('compositing');
      if (!e.target.value || !/^\d*\.?\d*$/.test(e.target.value)) {
        e.target.value = lastValidValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    input.addEventListener('input', (e) => {
      if (input.getAttribute('compositing')) return;

      const value = e.target.value;

      if (!value) {
        e.target.value = '1';
        lastValidValue = '1';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }

      if (/^\d*\.?\d*$/.test(value)) {
        lastValidValue = value;
      } else {
        e.target.value = lastValidValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }
};
